import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-address",
  "use": "icon-address-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-address\"><path d=\"M343.904 704c45.76 49.536 99.52 100.768 161.344 153.664 8 6.848 19.776 6.848 27.744 0C594.88 804.8 648.64 753.536 694.4 704H720l256 256H80l234.656-256h29.248z m-114.56-362.016C229.344 204.32 343.424 64 519.136 64s289.792 140.32 289.792 277.984c0 119.424-91.968 258.144-275.904 416.192a21.344 21.344 0 0 1-27.808 0c-183.904-158.048-275.872-296.768-275.872-416.192z m199.104-36.64a91.104 91.104 0 0 0 92 92 91.104 91.104 0 0 0 92-92 91.104 91.104 0 0 0-92-92 91.104 91.104 0 0 0-92 92z\" fill=\"#000000\" p-id=\"9872\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/address.svg
// module id = qREA
// module chunks = 42